import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ItemsListContentBaseComponent } from '../content-base/content-base.component';
import { ListData } from '@fi-app/components/items-list/list-data.service';

@Component({
    selector: 'fi-items-list-content-list-view-with-children-row-set',
    templateUrl: './content-list-view-with-children-row-set.component.html',
    styleUrls: ['./content-list-view-with-children-row-set.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-items-list-content-list-view-with-children-row-set' },
    standalone: false,
})
export class ItemsListContentListViewWithChildrenRowSetComponent<T> extends ItemsListContentBaseComponent {
    @Input() parentData: T;
    @Input() dataSet: Array<T>;
    @Input('settings') ngModel: ListData<T>;

    ngOnInit(): void {
        super.ngOnInit();
    }

    onShowMoreChildrenClick($event: MouseEvent, data: T) {
        $event.preventDefault();
        this.ngModel.showMoreChildren$.next(data);
    }

    isShowMoreChildrenVisible(data: T) {
        return (
            data[this.ngModel.ChildProperty] &&
            data[this.ngModel.ChildCountProperty] &&
            data[this.ngModel.ChildProperty].length < data[this.ngModel.ChildCountProperty]
        );
    }
}
